import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';

export const StartNode = memo((props: NodeProps) => {
  const { id, data } = props;

  return (
    <div className={'node start'} title="click to add a node">
      Start
      <Handle className={'handle'} type="target" position={Position.Top} isConnectable={false} />
      <Handle className={'handle'} type="source" position={Position.Bottom} isConnectable={false} />
    </div>
  );
});
